@layer module {
} // layer module










@layer app {
.input-amount-limits {
            margin-top: $size-10;
    }

.input-amount-limits {
            color: var(--custom-selector-icon-placeholder-bg);
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 400;
            line-height: $size-15;
    }
} // layer app
